import Localization from '../../assets/localization';

export class PopupWrapper {
  constructor () {
    this.localization = new Localization();
  }
}
